<template>
  <div class="faq-landing">
    <div v-if="$route.name !== 'FaqDetail' ">
      <div class="header" style="position: relative">
        <div class="content" style="display: flex">
          <div style="align-self: flex-end;width: 100%;" class="searchBox">
            <mu-row>
              <mu-col width="100" desktop="70" tablet="70" style="align-self: center; margin: 0 auto;">
                <form @submit.prevent="searchFaqs">
                  <h1>{{$t('message.labelFindExactlyWhatYouAreLookingFor')}}</h1>
                  <label for="search">
                    <mu-paper class="rounded">
                      <mu-text-field
                        inputClass="searchInput"
                        v-model="searchValue"
                        label=""
                        id="search"
                        name="search"
                        icon="search"
                        :underline-show="false"
                        full-width></mu-text-field>
                    </mu-paper>
                  </label>
                </form>
              </mu-col>
            </mu-row>
          </div>
        </div>
      </div>


      <div v-if="!isLoading" class="whiteContainer top">
        <div class="content">
          <mu-row gutter>
            <mu-col width="100" desktop="70" tablet="60" class="bottom">
              <mu-paper>
                <mu-list>
                  <mu-list-item
                    v-for="faq, faqIndex in faqs"
                    :key="'faq' +  faqIndex"
                    @click.native="goToFaq(faq.faq_id)">
                    <div slot="title" v-html="highlight(faq.question)"></div>
                  </mu-list-item>
                </mu-list>
              </mu-paper>
            </mu-col>
            <mu-col width="100" desktop="30" tablet="40">
              <mu-card>
                <mu-card-header :title="$t('message.labelMostUseful')" titleClass="blackTitle largeTitle"></mu-card-header>
                <mu-list>
                  <mu-list-item style="align-items: flex-start" v-for="useful, index in mostUseful"
                                :key="'index-' + useful.faq_id" @click.native="goToFaq(useful.faq_id)"
                                :title="useful.question">
                    <div slot="title" class="question">
                      {{useful.question}}
                    </div>

                  </mu-list-item>
                </mu-list>
              </mu-card>
            </mu-col>
          </mu-row>
        </div>
      </div>
      <div v-if="isLoading" class="top">
        <mu-content-block v-if="isLoading" align="center">
          <mu-circular-progress></mu-circular-progress>
        </mu-content-block>
      </div>
    </div>
    <div v-if="$route.name === 'FaqDetail'" class="faq-detail">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>


  import {Observable} from 'rxjs/Observable'
  import Faq from '../../api/Faq'

  export default {
    data() {
      return {
        isLoading: true,
        searchValue: null,
        categories: [],
        faqs: [],
        mostUseful: []
      }
    },
    mounted() {
      let self = this;
      const autoCompleteElement = $('.searchInput');
      const observableConditionElement = Observable.fromEvent(autoCompleteElement, 'keyup').map(x => x);
      const delayedSearch = observableConditionElement.debounceTime(300).distinctUntilChanged();
      delayedSearch.subscribe(function (e) {
        self.searchFaqs();
      });

      Faq.mostUseful()
        .then(function (response) {
          self.mostUseful = response.data;
        });


      Faq.getCategories()
        .then(function (response) {
          self.categories = response.data;
        });
      Faq.getAll()
        .then(function (response) {
          self.faqs = response.data;
          self.faqs.reverse();
          self.isLoading = false;
        })
        .catch(function (error) {
        })
    },
    methods: {
        goToFaq(id) {
          let self = this;
          self.$router.push({
            name: 'FaqDetail',
            params: {
              id: id
            }
          })
        },
        highlight(word) {
          let self = this;

          if (self.searchValue !== null) {
            let reg = new RegExp('('+self.searchValue+')', 'gi');
            let res = word.replace(reg, '<span class=\'highlight\'>' + self.searchValue + '</span>');
            return res;
          }
          else {
            return word;
          }
        },
        searchFaqs() {
          let self = this;

          if (self.searchValue === "") {
            Faq.getAll()
              .then(function (response) {
                self.faqs = response.data;
                self.faqs.reverse();
                self.isLoading = false;
              })

          }

          Faq.search(self.searchValue)
            .then(function (response) {
              if (response.data.length > 0) {
                self.faqs = response.data;
              }
            })
        }
      },
  }
</script>
<style lang="less">
  div#faq {
    background: white;
  }

  .faq-landing {
    h1 {
      color: white;
    }
    margin: -24px;
    .header {
      display: flex;
      min-height: 340px;
      background: url('~assets/faq/faq-header.svg') no-repeat no-repeat #0179d9;
      background-position: right;
      @media (max-width: 1024px) {
        .content {
          width: 100%;
        }
      }
      .searchBox {
        @media (max-width: 600px) {
          width: 80% !important;
          left: 34px;
          top: -24px;
        }
        position: relative;
        top: -148px;
        .mu-text-field-content {
          padding-top: 8px;
          padding-bottom: 8px;
        }
      }
    }
    .whiteContainer {
      background: white;
      @media (max-width: 600px) {
        margin: 8px 24px 0px 24px !important;
      }
    }
    .mu-text-field {
      padding-bottom: 0 !important;
      margin-bottom: 0px;
    }
    .rounded {
      border-radius: 4px;
    }
    .paperInput {
      height: 34px;
      display: block;
      width: 100%;
      border: 0;
      margin: 0;
      box-shadow: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
    .mu-item {
      line-height: 1.5;
    }

    .stat {
      font-size: 22px;
      color: #656565;
    }
    .mu-item.show-left {
      padding-left: 68px;

      .mu-icon {
        color: #a3c857;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?2cfbeedc